import React, { useState, useContext } from 'react'
import Modal from './Modal'
import {sendAnnounces} from '../../api/api'
import css from './Modal.module.scss'
import lCss from '../Layout/Layout.module.scss'
import {ERRORS_FORM_SEND_ANNOUNCE, FORM} from "../../constant"
import {EventContext, ModalContext} from "../../context"

export default function ModalSendAnnounces({isOpen, closeModal}) {
	const { toggleModal } = useContext(ModalContext)
	const { event } = useContext(EventContext)
	const [ form, setForm ] = useState({[FORM.EMAIL]: '', [FORM.MESSAGE]:''})
	const [ state, setState ] = useState({error: '', focus: false})
	const { error, focus } = state

	const onChange = function (e) {
		e.stopPropagation()
		const { name, value } = e.target
		setForm(prevState => ({...prevState, [name]: value}))
		setState(prevState => ({...prevState, error: '' }))
	}

	const onFocus = (e) => {
		const { name } = e.target
		setState(prevState => ({...prevState, focus: name }))
	}

	const successMail = function () {
		toggleModal({sendAnnounces:false, sendAnnouncesSuccess:true})
		setForm({[FORM.EMAIL]: '', [FORM.MESSAGE]:''})
	}

	const validate = () =>{
		const error = Object.keys(ERRORS_FORM_SEND_ANNOUNCE).find(e => (form[e] === '' || !form[e]))
		setState(prevState => ({...prevState, error: ERRORS_FORM_SEND_ANNOUNCE[error] }))

		return Boolean(error)
	}

	const onSubmit = async (e) => {
		e.preventDefault()
		if(!validate()) {
			const result = await sendAnnounces({...form,...{[FORM.SUBJECT]: parseInt(event.article_id)}})
			if (result?.message?.code === 200) {
				successMail()
			} else {
				closeModal()
			}
		}
	}

	const onClose = function () {
		closeModal()
	}
	
	return (
		<Modal
			isOpen={isOpen}
			closeModal={onClose}>
				<div className={css.title + ' '+css.login}>Отправить анонс по электронной почте</div>
				<form className={css.form} onSubmit={onSubmit}>
					<label className={css.field + ' ' + (focus === FORM.EMAIL ? css.focus : '') + ' ' + (form[FORM.EMAIL] ? css.hasValue : '')}>
						<span className={css.label}>E-mail</span>
						<input
							className={css.input}
							autoComplete="off"
							value={form[FORM.EMAIL]}
							name={FORM.EMAIL}
							type="text"
							onFocus={onFocus}
							onChange={onChange}/>
					</label>
					<label className={css.field + ' ' +(focus === FORM.MESSAGE ? css.focus : '') + ' ' + (form[FORM.MESSAGE] ? css.hasValue : '')}>
						<span className={css.label}>Текст сопроводительного письма</span>
						<textarea
							value={form[FORM.MESSAGE]}
							onChange={onChange}
							onFocus={onFocus}
							name="message"
							className={css.input}/>
					</label>
					<div className={css.field}>
						{error
							? <div className={lCss.button + ' ' + lCss.mt20 + ' ' + lCss.w100 + ' ' + lCss.error}>{error}</div>
							: <button className={lCss.button + ' ' + lCss.mt20 + ' ' + lCss.w250}>
								Отправить
							</button>
						}
					</div>
				</form>
		</Modal>
	)
}